// Fills its container and centers — the single loading indicator used by the
// list pages (via CustomTable) and HistoricalData, so they can't drift apart.
const Spinner = ({ label = 'Loading data…' }) => (
  <div className="flex-1 flex flex-col items-center justify-center gap-3 py-10 text-[#616a79]">
    <span className="w-8 h-8 rounded-full border-2 border-[#dfe4ed] border-t-[#006c4d] animate-spin" />
    {label && <span className="text-sm font-medium">{label}</span>}
  </div>
)

export default Spinner
